var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.15 62.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#00a193;}.cls-1{opacity:0.1;}.cls-2{fill:#00bcd4;}.cls-3{fill:none;}.cls-5{fill:#f6f6f6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.27,57.26a3.91,3.91,0,0,1-3.9,4.29H12.94a12,12,0,0,1-12-11.14A11.73,11.73,0,0,1,12.6,38.08H43.46a7.85,7.85,0,0,1,7.65,6.17l0,.13a8.8,8.8,0,0,1,.14,1.53,7.83,7.83,0,0,1-7.82,7.82h3.75a4,4,0,0,1,4.06,3.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.17,
    y1: 47.17,
    x2: 1.11,
    y2: 47.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 23.31,
    width: 52.15,
    height: 39.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52,44.22,49.41,31.56a10.48,10.48,0,0,0-10.2-8.25H13.81A10.45,10.45,0,0,0,3.62,31.56L.26,47.26v.07A12.57,12.57,0,0,0,12.94,62.42H47.37A4.76,4.76,0,0,0,48.46,53,8.67,8.67,0,0,0,52,44.25v0ZM5.32,31.92A8.74,8.74,0,0,1,13.81,25h25.4a8.73,8.73,0,0,1,8.49,6.87l1.54,7.52a8.63,8.63,0,0,0-5.78-2.22H12.6a12.49,12.49,0,0,0-9.12,3.92,1.71,1.71,0,0,1-.18.2ZM43.46,52.86H12.6a3,3,0,0,1-3-3.35,3.15,3.15,0,0,1,3.2-2.73H43.46a.87.87,0,0,0,0-1.74H12.78a4.91,4.91,0,0,0-4.93,4.3A4.79,4.79,0,0,0,12.6,54.6H47.21a3.15,3.15,0,0,1,3.19,2.74,3,3,0,0,1-.78,2.35,3,3,0,0,1-2.25,1H12.94A11,11,0,0,1,1.75,50.37,10.87,10.87,0,0,1,12.6,39H43.46a7,7,0,1,1,0,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.27,34a3.93,3.93,0,0,1-3.9,4.3H12.94A12,12,0,0,1,.89,27.1,11.73,11.73,0,0,1,12.6,14.78H43.46a7.83,7.83,0,0,1,7.65,6.16l0,.14a8.6,8.6,0,0,1,.14,1.52,7.82,7.82,0,0,1-7.82,7.82h3.75A4,4,0,0,1,51.27,34Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.17,
    y1: 23.87,
    x2: 1.11,
    y2: 24.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 52.15,
    height: 39.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.27,34a3.93,3.93,0,0,1-3.9,4.3H12.94A12,12,0,0,1,.89,27.1,11.73,11.73,0,0,1,12.6,14.78H43.46a7.83,7.83,0,0,1,7.65,6.16l0,.14a8.6,8.6,0,0,1,.14,1.52,7.82,7.82,0,0,1-7.82,7.82h3.75A4,4,0,0,1,51.27,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52,20.92,49.41,8.25A10.49,10.49,0,0,0,39.21,0H13.81A10.47,10.47,0,0,0,3.62,8.25L.26,24V24a12.57,12.57,0,0,0,12.68,15.1H47.37a4.77,4.77,0,0,0,4.76-5.25,4.85,4.85,0,0,0-3.67-4.16A8.66,8.66,0,0,0,52,20.94v0ZM5.32,8.61a8.72,8.72,0,0,1,8.49-6.87h25.4A8.72,8.72,0,0,1,47.7,8.61l1.54,7.52a8.63,8.63,0,0,0-5.78-2.22H12.6a12.49,12.49,0,0,0-9.12,3.92L3.3,18ZM43.46,29.55H12.6a3,3,0,0,1-3-3.34,3.16,3.16,0,0,1,3.2-2.74H43.46a.87.87,0,0,0,0-1.74H12.78A4.92,4.92,0,0,0,7.85,26a4.77,4.77,0,0,0,4.75,5.25H47.21A3.16,3.16,0,0,1,50.4,34a3,3,0,0,1-.78,2.35,3,3,0,0,1-2.25,1H12.94A11,11,0,0,1,1.75,27.06,10.87,10.87,0,0,1,12.6,15.65H43.46a7,7,0,1,1,0,13.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/51.42161ff4017a4ee957f432da85c70136.svg";
export { ForwardRef as ReactComponent };